import { createContext, useContext } from "react";

import type { ChatBubbleContextValue } from "./types";

const defaultChatBubbleContext: ChatBubbleContextValue = {
  variant: "receiver",
};

/**
 * Propagates the parent ChatBubble's `variant` so `ChatBubble.Body`,
 * `ChatBubble.Author`, `ChatBubble.Content`, and `ChatBubble.Timestamp`
 * resolve colours and alignment without repeating the prop on every child.
 */
export const ChatBubbleContext = createContext<ChatBubbleContextValue>(defaultChatBubbleContext);

export const useChatBubbleContext = (): ChatBubbleContextValue => useContext(ChatBubbleContext);
